/**
 * nc-gclid-capture.js — Capture des identifiants de clic Google Ads
 * (gclid / gbraid / wbraid) pour l'attribution des leads (Levier 2).
 *
 * Posture RGPD 1 (conforme, alignée sur le choix projet cf bandeau cookies) :
 * on ne PERSISTE et on n'ENVOIE ces identifiants que si le consentement marketing
 * est accordé.
 *   - Au chargement : si l'URL porte un id de clic, on le mémorise en sessionStorage
 *     (transient, non persistant, non traceur) — capture « au vol » de l'atterrissage.
 *   - Si le consentement marketing est (ou devient) accordé : on le persiste en cookie
 *     first-party (90 j) et on l'injecte en champ caché dans les formulaires devis,
 *     où nc-turnstile-forms.js (FormData) le remonte au Worker.
 *   - Sans consentement marketing : rien n'est persisté ni injecté ; les champs
 *     cachés éventuels sont retirés et le cookie est effacé.
 *
 * Le Worker n'exploite ces champs (upload Google Ads / Enhanced Conversions) que
 * lorsque la partie Worker du Levier 2 est déployée ; d'ici là ils enrichissent
 * simplement le lead (attribution manuelle possible).
 */
(function () {
  var IDS = ['gclid', 'gbraid', 'wbraid'];
  var COOKIE = '_nc_click_ids';
  var SESSION = 'nc_click_ids';
  var FORM_IDS = ['nc-devis-form', 'HeroDevisForm'];
  var MAX_AGE = 60 * 60 * 24 * 90; // 90 jours

  function marketingConsent() {
    try {
      var s = JSON.parse(localStorage.getItem('nc-consent-v2') || 'null');
      return !!(s && s.marketing);
    } catch (e) { return false; }
  }

  function fromUrl() {
    var q, out = {}, has = false;
    try { q = new URLSearchParams(location.search); } catch (e) { return null; }
    IDS.forEach(function (k) { var v = q.get(k); if (v) { out[k] = v; has = true; } });
    return has ? out : null;
  }

  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(SESSION) || 'null'); } catch (e) { return null; }
  }
  function writeSession(o) {
    try { sessionStorage.setItem(SESSION, JSON.stringify(o)); } catch (e) {}
  }

  function readCookie() {
    var m = document.cookie.match(/(?:^|;\s*)_nc_click_ids=([^;]+)/);
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }
  function writeCookie(o) {
    try {
      document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(o)) +
        ';path=/;max-age=' + MAX_AGE + ';SameSite=Lax;Secure';
    } catch (e) {}
  }
  function clearCookie() {
    try { document.cookie = COOKIE + '=;path=/;max-age=0;SameSite=Lax;Secure'; } catch (e) {}
  }

  // Identifiants disponibles : cookie persistant (si consenti) sinon session transiente.
  function currentIds() { return readCookie() || readSession() || null; }

  function injectInto(form, ids) {
    IDS.forEach(function (k) {
      var input = form.querySelector('input[name="' + k + '"][data-nc-clickid]');
      var val = ids && ids[k];
      if (val) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = k;
          input.setAttribute('data-nc-clickid', '');
          form.appendChild(input);
        }
        input.value = val;
      } else if (input && input.parentNode) {
        input.parentNode.removeChild(input);
      }
    });
  }

  function apply() {
    var consent = marketingConsent();
    if (consent) {
      var session = readSession();
      if (session && !readCookie()) writeCookie(session);
    } else {
      clearCookie();
    }
    var ids = consent ? currentIds() : null; // n'injecte QUE si consentement marketing
    FORM_IDS.forEach(function (id) {
      var form = document.getElementById(id);
      if (form) injectInto(form, ids);
    });
  }

  // 1. Capture au vol de l'atterrissage (toujours en session — transient, non traceur).
  var url = fromUrl();
  if (url) {
    var merged = readSession() || {};
    IDS.forEach(function (k) { if (url[k]) merged[k] = url[k]; });
    writeSession(merged);
  }

  // 2. Persister + injecter selon le consentement, maintenant et à chaque changement.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
  window.addEventListener('nc:consent-update', apply);
})();
